import { createRouter, createWebHistory } from "vue-router";
import HomeIndex from "../components/sites/HomeIndex.vue";
import KonzeptIndex from "../components/sites/KonzeptIndex.vue";
import ImpressumIndex from "../components/sites/ImpressumIndex.vue";
import TerminIndex from "../components/sites/termin/TerminIndex.vue";

// Kein Admin-Bereich auf linkberatung: Beratungswünsche werden zentral im
// Admin auf waizmann089.de verwaltet (gemeinsame Kalender-DB, APP_MODE=frontend).

const routes = [
  { path: "/", name: "home", component: HomeIndex },
  { path: "/konzept", name: "konzept", component: KonzeptIndex },
  { path: "/impressum", name: "impressum", component: ImpressumIndex },
  { path: "/sprechstunde", name: "sprechstunde", component: TerminIndex },
  { path: "/termin", redirect: { name: "sprechstunde" } },
  { path: "/:pathMatch(.*)*", redirect: "/" },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) return { el: to.hash, behavior: "smooth", top: 90 };
    return { top: 0 };
  },
});

export default router;
